import React from "react"
import { withRouter } from "react-router-dom"
import { Button, Header, Icon, Modal } from "semantic-ui-react"
import * as Sentry from "@sentry/react"

const ErrorModal = withRouter(({ error, clearError, location }) => {
  if (
    (error.message === "Forbidden" ||
      error.message === "Not Found" ||
      error.message === "CSRF token required") &&
    location.pathname.length > 1
  ) {
    // redirect ot signin view
    window.location = "/"
  } else {
    if (error.message === "Network Error") {
      return (
        <Modal open={true} basic size="small">
          <Header icon="warning sign" content="Network Error" />
          <Modal.Content>
            <p>
              Unable to communicate with application servers. Please check that
              you are connected to the internet.
            </p>
          </Modal.Content>
          <Modal.Actions>
            <Button id="intercom" inverted>
              <Icon name="chat" /> Contact Support
            </Button>
            <Button color="blue" onClick={() => clearError()}>
              Retry
            </Button>
          </Modal.Actions>
        </Modal>
      )
    } else if (error.status && error.status === 403) {
      const pathnames = window.location.pathname
        .split("/")
        .filter(name => name !== "")
      if (pathnames.length === 0) {
        window.location = `/home`
      } else if (pathnames.length === 1) {
        window.location = `/${pathnames[0]}`
      } else {
        window.location = `/${pathnames[0]}/${pathnames[1]}`
      }
    } else {
      Sentry.captureException(error)
      return (
        <Modal open={true} basic size="small">
          <Header icon="warning sign" content="Application Error" />
          <Modal.Content>
            <p>
              The application ran into a problem and needs to reload. If you get
              this message again please contact support.
            </p>
          </Modal.Content>
          <Modal.Actions>
            <Button id="intercom" inverted>
              <Icon name="chat" /> Contact Support
            </Button>
            <Button color="blue" onClick={() => (window.location = "/")}>
              <Icon name="refresh" /> Reload
            </Button>
          </Modal.Actions>
        </Modal>
      )
    }
  }
})

export default ErrorModal
